import uuid from 'react-uuid';

export interface AnalyticsSession {
    sessionId: string;
    startTimestamp: number;
}

// Must not be persisted: a page load starts a new session, matching Amplify's behavior.
let currentSession: AnalyticsSession | undefined;

export function getSession(now: number = Date.now()): AnalyticsSession {
    if (!currentSession) {
        currentSession = {
            sessionId: uuid(),
            startTimestamp: now,
        };
    }
    return currentSession;
}

export function resetSession(): void {
    currentSession = undefined;
}
